import { LargeLinkCard } from '@eika/link-panel';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';
import { useLinks } from '@hooks/use-links';
import { useTranslation } from '@translations';

export const SmartsparAd = () => {
    const { smartspar: smartsparLink } = useLinks();
    const { success, smartspar } = useTranslation();

    return (
        <LargeLinkCard
            url={smartsparLink.url}
            buttonText={smartspar.readMore}
            buttonType="positive"
            title={success.smartspar.title}
            text={success.smartspar.text}
            openInNewTab
            headerLevel="h2"
        >
            <RichIcon type={RichIconTypes.MOBILBANK_SPAREGRIS} />
        </LargeLinkCard>
    );
};
